export const STATUS_OK = 'ok';
export const STATUS_ERROR = 'error';
export const STATUS_PROCESS = 'process';
export const STATUS_APPROVE = 'need_approve';
export const STATUS_CONFIRM = 'need_confirm';
export const STATUS_SUCCESS = 'success';
export const PHONE_LENGTH = 10;
export const IIN_LENGTH = 16;
export const REMITTAMCES_TO_CARD = 'remittancesToCard';
export const REMITTAMCES_TO_CARD_MERCHANT = 'remittancesToCardMerchant';
export const REMITTAMCES_TO_SIM = 'remittancesToSim';
export const REMITTAMCES_FROM_CARD = 'remittancesFromCard';
export const SERVICES = 'services';
export const SIM = 'sim';
export const CARD = 'card';
export const DEFAULT = 'default';

// OPERATOR
export const TELE2 = 'tele2';
export const ALTEL = 'altel';
export const BEELINE = 'beeline';
export const ACTIV = 'active';
export const KCELL = 'kcell';

// Codes
export const IMBALANCE_CODE = '2019';
export const IMSUFFICIENT_FUNDS_CODE = '3012';
export const INVALID_TOKEN = 401;






